// extracted by mini-css-extract-plugin
module.exports = {"element":"image-m__element__1dSRv","loading":"image-m__loading__2BUJ4"};